var tooltipPadding = function tooltipPadding(_ref) {
  var contentHeight = _ref.contentHeight,
      theme = _ref.theme;

  // one-line text should have smaller top/bottom padding
  if (contentHeight <= Math.floor(parseFloat(theme.orbit.lineHeightTextNormal))) {
    return "".concat(theme.orbit.spaceXSmall, " ").concat(theme.orbit.spaceSmall); // TODO: create token
  }

  return theme.orbit.spaceSmall; // TODO: create token
};

export default tooltipPadding;